import { render, staticRenderFns } from "./CreateMailing.vue?vue&type=template&id=ba5e0e78&scoped=true&"
import script from "./CreateMailing.vue?vue&type=script&lang=js&"
export * from "./CreateMailing.vue?vue&type=script&lang=js&"
import style0 from "./CreateMailing.vue?vue&type=style&index=0&id=ba5e0e78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5e0e78",
  null
  
)

export default component.exports